<template>
  <NuxtLink :to="localePath(redirectTo)" class="block h-full w-full">
    <div class="relative h-full w-full break-words">
      <UiLazyImg
        v-if="isImage"
        class="absolute inset-0 z-[-1] h-full w-full"
        cover
        :src="imgFile?.url"
        :alt="imgFile?.original_name || $t('bannerImage')"
      />
      <video
        v-else-if="isVideo"
        :src="imgFile?.url"
        autoplay
        loop
        muted
        playsinline
        class="absolute inset-0 z-[-1] h-full w-full object-cover"
      />
      <div @click="contentLink" v-html="text" class="absolute inset-0"></div>
    </div>
  </NuxtLink>
</template>

<script lang="ts" setup>
import { MediaFile } from "ecom-types";
const props = defineProps<{
  redirectTo: string;
  imgFile: MediaFile;
  text: string;
}>();
const localePath = useLocalePathPolyfill();
const contentLink = useContentLink;

const isImage = computed(
  () => props.imgFile?.media_type?.split("/")[0] === "image",
);
const isVideo = computed(
  () => props.imgFile?.media_type?.split("/")[0] === "video",
);
</script>
